import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { fetchMapLocations } from 'containers/Maps/Map/mapSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import Dashboard from 'containers/Dashboard'
import Loading from 'components/Loading'
import Home from 'containers/Home'
import { useEffect } from 'react'

const StartPage: React.FC = () => {
  const isLoggedIn = useReduxSelector(selectIsLoggedIn)
  const isLoading = useReduxSelector(selectIsLoading)

  const dispatch = useReduxDispatch()
  useEffect(() => {
    if (process.env.REACT_APP_TYPE !== 'mm') {
      dispatch(fetchMapLocations())
    }
  }, [dispatch])

  return (
    isLoggedIn
      ? <Dashboard />
      : isLoading
        ? <Loading middleOfPage />
        : <Home />
  )
}

export default StartPage